/* eslint-disable no-underscore-dangle */
import React, { useState, useEffect } from 'react';
import moment from 'moment';

import Loading from '../../../shared/components/Loading';
import { getTimeseries } from '../../../shared/services/timeseries';
import { colors } from '../../../shared/styles/colors';
import MonitoringTimeseriesChart from '../Monitoring/MonitoringTimeseriesChart';

interface AlarmChartProps {
  timeseries: Record<string, string>;
  start: string;
  end: string;
}

const AlarmChart: React.FC<AlarmChartProps> = ({ timeseries, start, end }: AlarmChartProps) => {
  const [metricsData, setMetricsData] = useState<Record<string, (number | null)[][]>>();
  const [selected, setSelected] = useState<string>();
  const [running, setRunning] = useState(false);

  useEffect(() => {
    void (async () => {
      setRunning(true);
      const selector = JSON.stringify(timeseries);
      const timeseriesClone = { ...timeseries };
      delete timeseriesClone.__name__;
      const name = timeseries.__name__;

      const data = await getTimeseries(
        moment(start).subtract(30, 'm').toISOString(),
        moment(end).toISOString(),
        name,
        timeseriesClone
      );
      if (data !== null) {
        const metrics: Record<string, (number | null)[][]> = {};
        metrics[selector] = data;
        setSelected(selector);
        setMetricsData(metrics);
      }
      setRunning(false);
    })();
  }, [timeseries, start, end]);

  return (
    <div>
      {running && <Loading />}
      {metricsData && selected && (
        <MonitoringTimeseriesChart
          metricsData={metricsData}
          selected={selected}
          columnDefs={['time', 'value']}
          chartColors={colors}
          showLogScale={false}
        />
      )}
    </div>
  );
};

export default AlarmChart;
